import { Injectable } from '@angular/core'
import { fromEvent, Observable, of } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { UrlCollection } from '../url-collection'
import { map, mergeMap, switchMap } from 'rxjs/operators'
import { UrlAsObservableService } from '../app-config/url-as-observable.service'

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  constructor(
    private http: HttpClient,
    private urlAsObsService: UrlAsObservableService
  ) {}

  getImageByFileId(imageFileId: number): Observable<Blob> {
    return this.getImageByUrl(UrlCollection.Files.generateDownloadUrl(imageFileId))
  }

  getImageByUrl(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' })
  }

  /** takes a blob and converts it to a data-url to be used i.e. with an image src attribute. */
  createImageFromBlob(image: Blob): Observable<string | ArrayBuffer> {
    if (!image) {
      return of(null)
    }
    const reader = new FileReader()
    reader.readAsDataURL(image)
    return fromEvent(reader, 'load').pipe(map(() => reader.result))
  }

  /** gets the app-icon as img-src url */
  getAppLogo$ = (): Observable<string | ArrayBuffer> =>
    this.urlAsObsService.Config.APP_LOGO$().pipe(
      switchMap((url) => this.getImageByUrl(url)),
      switchMap((img) => this.createImageFromBlob(img))
    )

  getCustomerLogo$ = (): Observable<string | ArrayBuffer> =>
    this.urlAsObsService.Config.CUSTOMER_LOGO$().pipe(
      switchMap((url) => this.getImageByUrl(url)),
      switchMap((img) => this.createImageFromBlob(img))
    )
}
